"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextHeader = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.drule)({
    pd: '8px 20px',
});
const ContextHeader = ({ compact, children, ...rest }) => {
    const styles = (0, context_1.useStyles)();
    const className = (rest.className || '') +
        blockClass({
            bg: styles.g(0, 0.04),
        });
    const style = {
        ...rest.style,
        padding: compact ? '8px' : void 0,
    };
    return (React.createElement("div", { className: className, style: style }, children));
};
exports.ContextHeader = ContextHeader;
